import Vue from 'vue'
import EventBus from '../_event-bus'
import { $$ } from '../_utils'

Vue.component('vue-modal', {
  template: '#vue-modal-template',
  data() {
    return {
      addToCartText: '',
      isOpen: false,
      modal: {},
      pointsTitle: '',
    }
  },
  methods: {
    addToCart(id) {
      EventBus.$emit('add-to-cart', { id })
    },
    closeModal() {
      this.isOpen = false
      this.addToCartText = ''
      this.pointsTitle = ''
      this.modal = {}
    },
  },
  created() {
    EventBus.$on('open-modal', ({ addToCartText, modal, pointsTitle }) => {
      this.isOpen = true
      this.addToCartText = addToCartText
      this.modal = modal
      this.pointsTitle = pointsTitle
    })
  },
})

const modals = $$('#vue-modal-wrapper')
window.addEventListener('DOMContentLoaded', () => {
  modals.forEach(el => new Vue({ el }))
})
